import api from 'api'

export async function getPersonaIdPhoto(userId: string): Promise<string> {
  const response = await api.get(`/admin/user/${userId}/persona_id_photo`, {
    responseType: 'blob',
  })
  return URL.createObjectURL(response.data)
}
